// Bathroom Page Data and Functionality

const COLORS = [
    { code: "AW", name: "White", hex: "#f0ece4" },
    { code: "AA", name: "Ash", hex: "#c8bfb0" },
    { code: "AB", name: "Blue", hex: "#2c3e5a" },
    { code: "AC", name: "Charcoal", hex: "#3a3a3a" },
    { code: "AE", name: "Ebony", hex: "#1c1c1c" },
    { code: "AT", name: "Timber", hex: "#6b4226" },
    { code: "ALG", name: "Light Grey", hex: "#b0aaa0" },
    { code: "TG", name: "Fairy Green", hex: "#5a7a5a" },
    { code: "TW", name: "Swan White", hex: "#f5f0e8" },
    { code: "SF", name: "Frost", hex: "#ddd8cf" },
    { code: "SM", name: "Mocha", hex: "#5c4033" },
];

const BATH_CATS = [
    {
        title: "Vanity Drawer Bases",
        desc: "All-drawer vanities for storing toiletries, towels, and bathroom essentials. 21\" deep to fit standard bathrooms.",
        skus: 9, from: "$105", sizes: "12\"–36\" wide",
        items: [
            { sku: "VDB1221", w: 12, desc: "3 Drawer" }, { sku: "VDB1521", w: 15, desc: "3 Drawer" },
            { sku: "VDB1821", w: 18, desc: "3 Drawer" }, { sku: "VDB2121", w: 21, desc: "3 Drawer" },
            { sku: "VDB2421", w: 24, desc: "3 Drawer" }, { sku: "VDB2721", w: 27, desc: "3 Drawer" },
            { sku: "VDB3021", w: 30, desc: "3 Drawer" }, { sku: "VDB3321", w: 33, desc: "3 Drawer" },
            { sku: "VDB3621", w: 36, desc: "3 Drawer" },
        ],
        icon: "🗃️",
    },
    {
        title: "Vanity Sink Bases",
        desc: "Two-door vanity bases designed for under-sink plumbing with a false drawer front for a clean look.",
        skus: 5, from: "$138", sizes: "24\"–36\" wide",
        items: [
            { sku: "VSB2421", w: 24, desc: "2 Door + False Drawer" }, { sku: "VSB2721", w: 27, desc: "2 Door + False Drawer" },
            { sku: "VSB3021", w: 30, desc: "2 Door + False Drawer" }, { sku: "VSB3321", w: 33, desc: "2 Door + False Drawer" },
            { sku: "VSB3621", w: 36, desc: "2 Door + False Drawer" },
        ],
        icon: "🚰",
    },
    {
        title: "Vanity Sink & Drawer Combos",
        desc: "The best of both worlds — sink cabinet with functional drawer banks for maximum storage.",
        skus: 8, from: "$235", sizes: "30\"–60\" wide",
        items: [
            { sku: "VSD3021L", w: 30, desc: "1 Door + 2 Left Drawers" }, { sku: "VSD3021R", w: 30, desc: "1 Door + 2 Right Drawers" },
            { sku: "VSD3621L", w: 36, desc: "2 Door + 2 Left Drawers" }, { sku: "VSD3621R", w: 36, desc: "2 Door + 2 Right Drawers" },
            { sku: "VSD4221", w: 42, desc: "2 Door + 2 Drawer + False" },
            { sku: "VSD4821", w: 48, desc: "2 Door + 4 Drawer + False" },
            { sku: "VSD60SINGLE", w: 60, desc: "Single Sink — 2 Door + 6 Drawer + False" },
            { sku: "VSD60DOUBLE", w: 60, desc: "Double Sink — 4 Door + 3 Drawer + 2 False" },
        ],
        icon: "✨",
    },
    {
        title: "Knee Drawer",
        desc: "Shallow knee-height drawer for makeup vanity or seated workspace areas.",
        skus: 1, from: "$92", sizes: "30\" wide",
        items: [{ sku: "KD30", w: 30, desc: "Knee Drawer – 7-3/16\"H x 21\"D" }],
        icon: "💄",
    },
];

const STATEMENT_VANITIES = [
    { sku: "VSD4821", w: 48, title: "48\" Vanity with Drawers", desc: "2 doors, 4 drawers, and a false drawer front. The perfect primary bathroom centerpiece.", config: "2 Door + 4 Drawer + False Drawer" },
    { sku: "VSD60SINGLE", w: 60, title: "60\" Single Sink Vanity", desc: "Maximum counter space with a single basin. 2 doors, 6 drawers — ultimate storage.", config: "2 Door + 6 Drawer + False Drawer" },
    { sku: "VSD60DOUBLE", w: 60, title: "60\" Double Sink Vanity", desc: "His-and-hers configuration. 4 doors, 3 drawers, 2 false drawer fronts.", config: "4 Door + 3 Drawer + 2 False Drawer" },
];

const BATH_ACCESSORIES = [
    { name: "Floating Shelves", desc: "30\", 36\", or 48\" wide wall shelves", icon: "📚", skus: 3 },
    { name: "Fillers", desc: "Base fillers in 3\" and 6\" widths", icon: "📏", skus: 2 },
    { name: "Side Panels", desc: "Matching end panels for exposed sides", icon: "🎨", skus: 3 },
    { name: "Molding & Trim", desc: "Crown, light rail, scribe molding", icon: "🪵", skus: 14 },
];

const BATH_SPECS = [
    { label: "Depth", val: '21"', sub: "Standard bathroom fit" },
    { label: "Height", val: '34½"', sub: "Standard vanity height" },
    { label: "Drawer Box", val: "⅝\" Dovetail", sub: "Solid birch, soft-close" },
    { label: "Door Style", val: "3 Series", sub: "Traditional, Beveled, Slim" },
];

let activeTab = 0;

// Render color swatches
function renderColorSwatches() {
    const container = document.getElementById('colorSwatches');
    if (!container) return;
    
    container.innerHTML = '';
    COLORS.forEach(color => {
        const swatch = document.createElement('div');
        swatch.className = 'color-swatch';
        swatch.style.background = color.hex;
        swatch.title = `${color.name} (${color.code})`;
        container.appendChild(swatch);
    });
}

// Render tab bar
function renderTabBar() {
    const container = document.getElementById('tabBar');
    if (!container) return;
    
    container.innerHTML = '';
    BATH_CATS.forEach((cat, idx) => {
        const tab = document.createElement('div');
        tab.className = idx === 0 ? 'tab-item active' : 'tab-item';
        tab.innerHTML = `
            <span class="tab-item-icon">${cat.icon}</span>
            ${cat.title}
            <span class="tab-item-count">(${cat.skus})</span>
        `;
        tab.onclick = () => switchTab(idx);
        container.appendChild(tab);
    });
}

// Switch tabs
function switchTab(index) {
    activeTab = index;
    
    // Update tab bar
    document.querySelectorAll('.tab-item').forEach((tab, idx) => {
        tab.classList.toggle('active', idx === index);
    });
    
    // Update content
    document.querySelectorAll('.tab-content-section').forEach((section, idx) => {
        section.classList.toggle('active', idx === index);
    });
}

// Render tab content
function renderTabContent() {
    const container = document.getElementById('tabContent');
    if (!container) return;
    
    container.innerHTML = '';
    
    BATH_CATS.forEach((cat, catIdx) => {
        const section = document.createElement('div');
        section.className = catIdx === 0 ? 'tab-content-section active' : 'tab-content-section';
        
        // Info Grid
        const infoGrid = document.createElement('div');
        infoGrid.className = 'tab-info-grid';
        infoGrid.innerHTML = `
            <div>
                <p class="tab-info-text">${cat.desc}</p>
                <div class="tab-info-badges">
                    <span class="spec-badge">${cat.skus} sizes</span>
                    <span class="spec-badge">${cat.sizes}</span>
                    <span class="spec-badge">From ${cat.from}</span>
                    <span class="spec-badge">21" deep</span>
                </div>
            </div>
            <div class="tab-info-actions">
                <button class="btn btn-primary btn-sm" onclick="window.location.href='catalog.html'">Shop ${cat.title} →</button>
                <button class="btn btn-outline btn-sm">Get Free Design</button>
            </div>
        `;
        section.appendChild(infoGrid);
        
        // Products Grid
        const productsGrid = document.createElement('div');
        productsGrid.className = 'vanity-products-grid';
        productsGrid.style.gridTemplateColumns = cat.items.length <= 4 ? `repeat(${Math.min(cat.items.length, 4)}, 1fr)` : 'repeat(4, 1fr)';
        
        cat.items.forEach(item => {
            const card = document.createElement('div');
            card.className = 'vanity-product-card';
            card.onclick = () => window.location.href = 'catalog.html';
            
            card.innerHTML = `
                <div class="vanity-product-image">
                    <div>
                        <div class="vanity-width">${item.w}"</div>
                        <div class="vanity-width-label">wide</div>
                    </div>
                </div>
                <div class="vanity-product-body">
                    <div class="vanity-sku">${item.sku}</div>
                    <div class="vanity-desc">${item.desc}</div>
                    <div class="vanity-colors">
                        ${COLORS.slice(0, 7).map(c => `<div class="vanity-color-dot" style="background:${c.hex}"></div>`).join('')}
                        <div class="vanity-color-more">+4</div>
                    </div>
                    <div class="vanity-link">View Details →</div>
                </div>
            `;
            
            productsGrid.appendChild(card);
        });
        
        section.appendChild(productsGrid);
        container.appendChild(section);
    });
}

// Render statement vanities
function renderStatementVanities() {
    const container = document.getElementById('statementVanities');
    if (!container) return;
    
    container.innerHTML = '';
    STATEMENT_VANITIES.forEach(vanity => {
        const card = document.createElement('div');
        card.className = 'statement-card';
        card.onclick = () => window.location.href = 'catalog.html';
        
        card.innerHTML = `
            <div class="statement-image">
                <div>
                    <div class="statement-width">${vanity.w}"</div>
                    <div class="statement-width-label">wide</div>
                </div>
            </div>
            <div class="statement-body">
                <div class="statement-sku">${vanity.sku}</div>
                <div class="statement-title-text">${vanity.title}</div>
                <p class="statement-desc">${vanity.desc}</p>
                <span class="spec-badge">${vanity.config}</span>
                <div class="statement-colors">
                    ${COLORS.slice(0, 7).map(c => `<div class="statement-color-dot" style="background:${c.hex}"></div>`).join('')}
                    <div class="statement-color-more">+4</div>
                </div>
                <button class="btn btn-dark btn-sm" style="width: 100%; justify-content: center;">Shop This Vanity →</button>
            </div>
        `;
        
        container.appendChild(card);
    });
}

// Render bathroom accessories
function renderBathAccessories() {
    const container = document.getElementById('bathAccessories');
    if (!container) return;
    
    container.innerHTML = '';
    BATH_ACCESSORIES.forEach(acc => {
        const card = document.createElement('div');
        card.className = 'bath-accessory-card';
        card.onclick = () => window.location.href = 'catalog.html';
        
        card.innerHTML = `
            <span class="accessory-icon">${acc.icon}</span>
            <div class="accessory-name">${acc.name}</div>
            <div class="accessory-desc">${acc.desc}</div>
        `;
        
        container.appendChild(card);
    });
}

// Render bathroom specs
function renderBathSpecs() {
    const container = document.getElementById('bathSpecs');
    if (!container) return;
    
    container.innerHTML = '';
    BATH_SPECS.forEach(spec => {
        const card = document.createElement('div');
        card.className = 'bath-spec-card';
        
        card.innerHTML = `
            <div class="spec-label-bath">${spec.label}</div>
            <div class="spec-value-bath">${spec.val}</div>
            <div class="spec-sub-bath">${spec.sub}</div>
        `;
        
        container.appendChild(card);
    });
}

// Initialize bathroom page
document.addEventListener('DOMContentLoaded', function() {
    renderColorSwatches();
    renderTabBar();
    renderTabContent();
    renderStatementVanities();
    renderBathAccessories();
    renderBathSpecs();
});
